import * as React from "react";

import "./pdf-download.scss";

import {IsShowPricing}  from "@Common/logic/check-show-pricing";
import {cs}             from "@Common/react/chain-services";
import {formatMoney}    from "@Common/ui-components/language/format-money";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

import {MoneySpan} from "../../../../../common/form/money-span/money-span";

export const PdfDownload = ({state, pdfDownloadPrice}) => cs(
    ({}, next) => pdfDownloadPrice == null ? null : next(),
    ["showPricing", (_, next) => IsShowPricing({next})],
    ({showPricing}) => (
        <div className="pdf-download-643" xd-qa-type="card" xd-qa-name="File Download">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="File Download">
                    File Download
                </div>
                <div className="sub-title" xd-qa-type="label" xd-qa-name="File Download Description">
                    Include a high-resolution PDF
                </div>
            </div>

            <div className="card">
                <div className="line">
                    <div className="left">
                        <div className="title" xd-qa-type="label" xd-qa-name="PDF Download on Purchase">
                            PDF Download on Purchase
                        </div>

                        {showPricing && (
                            MoneySpan({value: pdfDownloadPrice ?? 0,xdQaName:"File Download Amount"})
                        )}
                    </div>

                    <SliderCheckbox {...{
                        ...state,
                        xdQaName: "PDF Download on Purchase",
                    }}/>
                </div>
            </div>
        </div>
    ),
);


const formatMoney1 = (amount) => !amount ? "FREE" : formatMoney(amount);